module.exports = __webpack_public_path__ + "img/video_img3.5949e3da.png";